const accountBtn = document.getElementById("accountBtn");
const accountMenu = document.getElementById("accountMenu");

accountBtn.addEventListener("click", function (e) {
  e.stopPropagation();
  accountMenu.classList.toggle("show");
});

// Close dropdown when clicking outside
document.addEventListener("click", function () {
  accountMenu.classList.remove("show");
});


document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('template-product')) return;
  
  const table = document.querySelector('.product_family_list table');

  if (!table) return;

  const headerCells = table.querySelectorAll('thead th');

  headerCells.forEach((th, index) => {
    let hasData = false;

    table.querySelectorAll('tbody tr').forEach(row => {
      const td = row.querySelectorAll('td')[index];

      if (td && td.textContent.trim()) {
        hasData = true;
      }
    });

    if (!hasData) {
      th.style.display = 'none';

      table.querySelectorAll('tbody tr').forEach(row => {
        const td = row.querySelectorAll('td')[index];
        if (td) td.style.display = 'none';
      });
    }
  });

      //Ak custom code
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.plus, .minus');
      if (!btn) return;

      const qtyWrapper = btn.closest('.pdp_qty');
      if (!qtyWrapper) return;

      // Wait for the quantity input to update
      setTimeout(() => {
        const qty = parseInt(qtyWrapper.querySelector('.qty').value, 10) || 1;

        const priceContainers = document.querySelectorAll('.product--price-container');

        priceContainers.forEach(function(priceEL){
          const unitPrice = parseFloat(priceEL.dataset.price);
          const totalPrice = unitPrice * qty;
          priceEL.querySelector('.price ins span').innerHTML = Shopify.formatMoney(totalPrice, Shopify.money_format);
        });
      }, 10);
    });
    //Ak custom code
    
});

document.addEventListener('DOMContentLoaded', function () {
  
  if (!document.body.classList.contains('template-product')) return;

  document.querySelectorAll('collapsible-row').forEach(function (accordion) {
    const table = accordion.querySelector('table');

    if (!table) return;

    const cells = table.querySelectorAll('td, th');
    let hasContent = false;

    cells.forEach(function (cell) {
      if (cell.textContent.trim() !== '') {
        hasContent = true;
      }
    });

    if (!hasContent) {
      accordion.style.display = 'none';
    }
  });
});(function () {
  var aBar = document.querySelector('.announcement-bar');
  var headerSection = document.querySelector('.header-section');

  var announcementHeight = aBar ? aBar.getBoundingClientRect().height : 0;
  // document.documentElement.style.setProperty('--announcement-height', announcementHeight + 'px');

  if (headerSection) {
    var headerTop = headerSection.getBoundingClientRect().top;
    var offset = headerTop > 0 ? headerTop : announcementHeight;
    document.documentElement.style.setProperty('--header-offset', offset + 'px');
  }
})();